export default __webpack_public_path__ + "static/media/jobsite.5e082dce.svg";